import React from "react";
import Widget from "../Widget";
import { observer, inject } from "mobx-react";
import { action, makeObservable } from "mobx";
import "./Ventilator.scss";
import VentilatorStore from "./VentilatorStore";
import Loader from "../../shared/Loader/Loader";
import Grid from "../../shared/Grid/Grid";
import DiscretesAndTrends from "../../shared/DiscretesAndTrends";
import config from "../../config";

class Ventilator extends Widget {
  constructor(props) {
    super(props);

    makeObservable(this, {
      toggleChart: action,
    });

    this.setRouteProps(["asmpid"]);
    this.store = new VentilatorStore({ asmpid: this.asmpid });
    this.toggleChart = this.toggleChart.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  render() {
    return (
      <div className="ventilator widget">
        <DiscretesAndTrends
          discretes={this.store.charts}
          discreteGroups={this.store.discreteGroups}
          fetchTrends={this.store.fetchTrend}
        />
        {this.store.labs && this.store.settings ? (
          <Grid labs={this.store.labGroups} history={this.props.history} />
        ) : (
          <Loader />
        )}
        {this.store.loading ? <Loader /> : ""}
        {this.store.error ? (
          <div className="error">{this.store.error}</div>
        ) : (
          ""
        )}
      </div>
    );
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.store.dispose();
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Ventilator error", error, info);
  }

  refresh() {
    this.store.fetchVentConfig();
    this.store.fetchDiscretes();
    this.store.fetchSettings();
    if (config.emr) {
      this.store.fetchLabs();
    }
  }

  async toggleChart(chart) {
    chart.active = !chart.active;
    if (chart.active) {
      this.store.fetchTrend(chart);
      let path = `/patient/${this.asmpid}/ventilator/graphs`;
      if (this.props.match.url !== path) {
        this.props.history.push(path);
      }
    }
  }
}

export default inject("store")(observer(Ventilator));
